<template>
  <div style="display: flex; flex-wrap: wrap">
    <div v-for="item in formData" class="form-item" :key="item.index">
      <div style="flex: 1">
        {{ item.label }}
      </div>
      <div>:</div>
      <div>
        <Comp :data="item" :key="item.id" />
      </div>
    </div>
  </div>
</template>

<script>
import Comp from "./comp.vue";

export default {
  data() {
    return {
      formList: [],
    };
  },
  // inject: ['formData'],
  // computed: {
  //     formList() {
  //         return this.formData
  //     }
  // },
  Watch: {
    formData: {
      // 监听数据发生变化的处理函数
      handler(val) {
        this.formList = val;
      },
      deep: true,
    },
  },
  props: {
    formData: {
      type: Array,
    },
    msg: {
      type: String,
    },
  },
  components: { Comp },
};
</script>

<style scoped lang="scss">
.form-item {
  display: flex;
  align-items: center;
  gap: 0.6em;
  margin: 6px 0;
}
</style>